import { Component, Input, output, OutputEmitterRef, ViewChild } from '@angular/core';
import { CalendarComponent } from '../calendar/calendar.component';
import { DateTime } from 'luxon';
import { Cronogramas } from 'src/app/domain/modelsForComponents/cronograma.model';
import { ControlsModule } from 'segov-sigepo-lib';
import { SegovSigepoDropdownCustomizableComponent } from 'segov-sigepo-public-api';

@Component({
  selector: 'app-dropdown-calendario',
  standalone: true,
  imports: [
    CalendarComponent,
    ControlsModule
  ],
  templateUrl: './dropdown-calendario.component.html',
  styleUrl: './dropdown-calendario.component.css'
})

export class DropdownCalendarioComponent {
  @Input() dataApresentada: DateTime = DateTime.local();
  @Input() Cronogramas!: Cronogramas;
  @Input() visualizacaoPdf = false;

  @ViewChild(SegovSigepoDropdownCustomizableComponent) dropdownComponent!: SegovSigepoDropdownCustomizableComponent;

  public width = 376;
  public dataClicada: OutputEmitterRef<Date> = output();
  public alternarMes: OutputEmitterRef<Date> = output();
  public redirecionarUltimaEdicao = output<void>();

  public onClicarData(event:DateTime){
    this.dropdownComponent.toggleDropdown();
    if(this.dataApresentada.month !== event.month || this.dataApresentada.year !== event.year) {
      this.alternarMes.emit(event.toJSDate());
    }
    this.dataClicada.emit(event.toJSDate());
  }

  public onMudancaDeMes(event: DateTime){
    this.alternarMes.emit(event.toJSDate());
    this.dataApresentada = event;
  }
}
